<div
  fxFlex
  fxLayout="row"
  fxLayoutAlign="start center"
  class="header mat-elevation-z5"
>
  <div fxFlex="30" class="header-left">
    <!-- <mat-icon class="primary-color">{{menuItem?.icon}}</mat-icon> -->
    <img [src]="menuItem?.icon" />
    <span class="primary-color">{{ menuItem?.label }}</span>
  </div>
  <div fxFlex="30" class="multicolortext">
    <!-- MOR Analytics - Antology -->
  </div>
  <div fxFlex="40" class="header-right">
    <button
      class="primary-bg-color"
      [matMenuTriggerFor]="menu"
      mat-fab
      aria-label="Example icon button with a bookmark icon"
    >
      <mat-icon>face</mat-icon>
    </button>

    <mat-menu #menu="matMenu">
      <label>{{
        personalInfo?.firstName ? personalInfo.firstName : "Admin"
      }}</label>
      <mat-divider></mat-divider>
      <button mat-menu-item>
        Settings
        <mat-icon class="menu-icons primary-color">settings</mat-icon>
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="logout()">
        Logout
        <mat-icon class="menu-icons primary-color">logout</mat-icon>
      </button>
    </mat-menu>
  </div>
</div>
